import React, { FC, ReactNode, useState, useEffect, useRef } from 'react';

export interface StickyBoxSheetProps {
	legalLayout?: ReactNode;
	buttonLayout?: ReactNode;
}

const StickyBoxSheet: FC<StickyBoxSheetProps> = (props) => {
	const { legalLayout, buttonLayout } = props;
	const containerRef = useRef<HTMLDivElement>(null);
	const [height, setHeight] = useState(0);

	useEffect(() => {
		if (!containerRef?.current?.clientHeight) {
			return;
		}
		setHeight(containerRef?.current?.clientHeight);
	}, [containerRef?.current?.clientHeight]);

	return (
		<div style={{ height }}>
			<div
				className="absolute left-0 right-0 bottom-0 flex flex-col gap-contentSmall py-contentSmall bg-containerLow"
				ref={containerRef}
			>
				{legalLayout && <div className="px-contentMedium">{legalLayout}</div>}
				<div className="py-contentXS">{buttonLayout}</div>
			</div>
		</div>
	);
};

export default StickyBoxSheet;
